import CompanyRoutes from "../../apiRoutes/CompanyRoutes";
import { GET, POST } from "../ConsumeApiController";

export async function getViews(viewable_type,viewable_id)
{
    const response = await GET(CompanyRoutes.Analitycs.Views+`${viewable_type}/${viewable_id}`);
    return response;
}